import { useEffect, useState } from "react";
import { X, Cookie } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const KEY = "axomind_cookie_consent_v1";

export default function CookieBanner() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const v = localStorage.getItem(KEY);
    if (!v) {
      const t = setTimeout(() => setOpen(true), 1500);
      return () => clearTimeout(t);
    }
  }, []);

  const decide = (v) => {
    localStorage.setItem(KEY, v);
    setOpen(false);
  };

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          role="dialog"
          aria-live="polite"
          aria-label="Cookie consent"
          data-testid="cookie-banner"
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.4 }}
          className="fixed bottom-4 left-4 right-4 sm:left-1/2 sm:-translate-x-1/2 sm:right-auto sm:bottom-6 sm:w-[28rem] sm:max-w-[calc(100vw-2rem)] z-[55] glass-strong rounded-2xl p-5 border-[#D4AF37]/30"
        >
          <div className="flex items-start gap-3">
            <Cookie className="text-[#D4AF37] mt-1 shrink-0" size={20} />
            <div className="flex-1">
              <div className="font-display font-semibold text-white">We value your privacy</div>
              <p className="text-sm text-gray-400 mt-1 leading-relaxed">
                We use cookies to enhance your browsing experience, analyse site traffic and serve relevant content.
                See our{" "}
                <a href="/legal/privacy-policy" className="text-[#D4AF37] hover:underline">
                  Privacy Policy
                </a>
                .
              </p>
              <div className="mt-4 flex gap-2">
                <button
                  onClick={() => decide("accepted")}
                  data-testid="cookie-accept"
                  className="px-4 py-2 rounded-full bg-[#D4AF37] text-black font-semibold text-sm hover:bg-[#FFD700] transition"
                >
                  Accept all
                </button>
                <button
                  onClick={() => decide("rejected")}
                  data-testid="cookie-reject"
                  className="px-4 py-2 rounded-full bg-white/5 border border-white/10 text-gray-200 font-medium text-sm hover:border-white/30 transition"
                >
                  Reject non-essential
                </button>
              </div>
            </div>
            <button
              onClick={() => decide("dismissed")}
              aria-label="Dismiss"
              className="text-gray-500 hover:text-white transition shrink-0"
              data-testid="cookie-close"
            >
              <X size={18} />
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
